import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  Lookup,
  StateStoring,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarTaxasDs } from "../../DataSources";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroTaxasGridState";

let _taxaCorrente = undefined;

export default class TaxasBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: { nome: "" },
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    console.log(props);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.taxasDs = criarTaxasDs();
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("taxas/editar/" + e.data.id);
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (filtro.id !== undefined) {
      filtroCorrente.push(["id", "contains", filtro.id.trim()]);
    }
    if (filtro.descricao !== undefined) {
      filtroCorrente.push(["descricao", "contains", filtro.descricao.trim()]);
    }
    if (filtro.receitaId !== undefined) {
      filtroCorrente.push(["receitaId", "contains", filtro.receitaId.trim()]);
    }

    this._gridInstance.instance.filter(filtroCorrente);
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  render() {
    const tiposDeCobrancaFaixa = [
      { id: 0, descricao: "Quantidade" },
      { id: 1, descricao: "Faixa" },
      { id: 2, descricao: "Valor Fixo" },
      { id: 3, descricao: "Por Faixa (Tabela Preços)" },
    ];

    const tiposTaxa = [
      { id: 0, descricao: "Taxas Diversas" },
      { id: 1, descricao: "Alvará Funcionamento" },
      { id: 2, descricao: "Alvará Sanitário" },
      { id: 3, descricao: "Alvará Diversos" },
    ];
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form id="frmPesquisa" formData={this.state.filtro} colCount={9}>
            <SimpleItem dataField="id" colSpan={2}>
              <Label text="Código da Taxa" />
            </SimpleItem>
            <SimpleItem dataField="descricao" colSpan={5}>
              <Label text="Descrição" />
            </SimpleItem>
            <SimpleItem dataField="receitaId" colSpan={2}>
              <Label text="Código da Receita" />
            </SimpleItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <br />
        <br />
        <PaginaToolbar titulo="Taxas" novoCb={this.novaTaxa.bind(this)}>
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.taxasDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            focusedRowEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
            onEditingStart={this.onAtualizandoRow}
          >
            <Editing
              allowDeleting={!this.usadoComoPesquisa}
              allowUpdating={!this.usadoComoPesquisa}
              useIcons={true}
              visible={!this.usadoComoPesquisa}
            />
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              buttons={[
                "edit",
                "delete",
                {
                  hint: "Selecionar",
                  icon: "repeat",
                  visible: this.usadoComoPesquisa,
                  onClick: this.onSelecionado,
                },
              ]}
            />
            <Column
              dataField={"sequencial"}
              visibleIndex={1}
              allowEditing={false}
              caption={"#"}
              width={80}
            >
              <FormItem visibleIndex={1} />
            </Column>
            <Column
              dataField={"id"}
              caption={"#"}
              width={"80px"}
              alignment={"center"}
              visible={false}
            />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            >
              <FormItem visible={false}></FormItem>
            </Column>
            <Column dataField={"descricao"} caption={"Descrição"} />

            <Column dataField={"tipoDeCobranca"} caption={"Tipo de Cobrança"}>
              <Lookup
                dataSource={tiposDeCobrancaFaixa}
                valueExpr={"id"}
                displayExpr={"descricao"}
              />
            </Column>
            <Column dataField={"tipoTaxa"} caption={"Tipo de Taxa"}>
              <Lookup
                dataSource={tiposTaxa}
                valueExpr={"id"}
                displayExpr={"descricao"}
              />
            </Column>
            <Column dataField={"valor"} caption={"Valor"} format={uiInfo.formatoNumerico.n2} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }

  novaTaxa() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("taxas/novo");
  }
}
